import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import { push } from "react-router-redux";
import {
  EMAIL_VARIFICATION_REQUEST,
  emailVarificationSuccess,
  emailVarificationError,
} from "./actions";
import { Env } from "../../env";

function* EmailVarificationRequest(action) {
  console.log(action);
  const { uid, token } = action.accessToken;
  let response;
  try {
    response = yield call(axios.get, `${Env.BASE_API_URL}/Accounts/confirm`, {
      params: {
        uid: uid,
        token: token,
      },
    });
  } catch (err) {
    let error;
    if (err.response && err.response.status === 404) {
      error = "utilisateur non trouvé";
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
    }
    console.log("error", err);
    yield put(emailVarificationError(error));
    yield put(flashMessage(error));
    yield put(push("/login"));
    return;
  }
  console.log("response", response);
  yield put(emailVarificationSuccess());
  yield put(flashMessage("Vérification du courrier électronique avec succès"));
  yield put(push("/login"));
}

export default function* watchEmailVarificationRequest() {
  yield takeLatest(EMAIL_VARIFICATION_REQUEST, EmailVarificationRequest);
}



// WEBPACK FOOTER //
// ./src/pages/confirmemail/saga.js